// extracted by mini-css-extract-plugin
export default {"container":"AddCustom--container--ac27ec","label":"AddCustom--label--d12660"};